import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyLists } from './useGetLists';
import { getQueryKey as getQueryKeyList } from './useGetListById';

// Config
import { uiConfig } from '../../../conf/lists';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.LIST);

export const useInsertList = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ newList }) => Client.insert(sessionToken, newList),
        onSuccess: (data, variables) => {
            updateCacheArray({
                queryKey: getQueryKeyLists(),
                action: CACHE_ACTIONS.INSERT,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyList(data.listId)
            });
            onSuccessCb?.({ data: data.listId, context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
